document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.size-options').forEach(group=>{
    const select=document.getElementById(group.dataset.select);
    const buttons=group.querySelectorAll('.size-button');
    buttons.forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled) return;
      buttons.forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      if(select){
        select.value=btn.dataset.variantId;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }));
    const first=[...buttons].find(b=>!b.disabled);
    if(first){first.classList.add('active');if(select)select.value=first.dataset.variantId;}
  });

  const popup=document.querySelector('[data-exit-discount]');
  if(!popup) return;
  const close=popup.querySelector('[data-exit-close]');
  const copy=popup.querySelector('[data-copy-code]');
  const code=popup.querySelector('[data-discount-code]');
  const storageKey='mireille_exit_discount_seen';

  const show=()=>{
    const isDesktopPointer=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(!isDesktopPointer || sessionStorage.getItem(storageKey)) return;
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden','false');
    sessionStorage.setItem(storageKey,'1');
  };

  const hide=()=>{
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden','true');
  };

  document.addEventListener('mouseout',(e)=>{
    const leavingTop=e.clientY<=8;
    const notMovingToElement=!e.relatedTarget && !e.toElement;
    if(leavingTop && notMovingToElement) show();
  });

  close&&close.addEventListener('click',hide);
  popup.addEventListener('click',(e)=>{if(e.target===popup) hide();});
  document.addEventListener('keydown',(e)=>{if(e.key==='Escape') hide();});

  copy&&copy.addEventListener('click',async()=>{
    const value=code ? code.textContent.trim() : 'MIREILLE10';
    try{await navigator.clipboard.writeText(value);copy.textContent='Copied';}
    catch(err){copy.textContent=value;}
  });
});
